import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface ErrorState {
	error: {
		message: string | null;
		status: number | null;
	} | null;
}

const initialState: ErrorState = {
	error: null,
};

interface SetErrorPayload {
	error: string;
	status: number;
}

export const name = 'error';

const errorSlice = createSlice({
	name,
	initialState,
	reducers: {
		clearError(state) {
			state.error = null;
		},
		setError(state, action: PayloadAction<SetErrorPayload>) {
			const { payload } = action;

			state.error = {
				message: payload.error,
				status: payload.status,
			};
		},
	},
});

export const { clearError, setError } = errorSlice.actions;
export default errorSlice.reducer;
